import {
  GET_ALL_CONTACTUSS,
  GET_ALL_CONTACTUSS_SUCCESS,
  GET_ALL_CONTACTUSS_FAILURE,
  EDIT_CONTACTUS,
  EDIT_CONTACTUS_SUCCESS,
  EDIT_CONTACTUS_FAILURE,
  DELETE_CONTACTUS,
  DELETE_CONTACTUS_SUCCESS,
  DELETE_CONTACTUS_FAILURE,
  GET_CONTACTUS,
  GET_CONTACTUS_SUCCESS,
  GET_CONTACTUS_FAILURE,
  ADD_CONTACTUS,
  ADD_CONTACTUS_SUCCESS,
  ADD_CONTACTUS_FAILURE,
} from "./actionTypes";

export const getAllContactUss = () => {
  return {
    type: GET_ALL_CONTACTUSS,
  };
};
export const getAllContactUssSuccess = (payload) => {
  return {
    type: GET_ALL_CONTACTUSS_SUCCESS,
    payload: payload,
  };
};

export const getAllContactUssFailure = (error) => {
  return {
    type: GET_ALL_CONTACTUSS_FAILURE,
    payload: error,
  };
};

export const editContactUs = (payload) => {
  return {
    type: EDIT_CONTACTUS,
    payload: payload,
  };
};
export const editContactUsSuccess = (payload) => {
  return {
    type: EDIT_CONTACTUS_SUCCESS,
    payload: payload,
  };
};

export const editContactUsFailure = (error) => {
  return {
    type: EDIT_CONTACTUS_FAILURE,
    payload: error,
  };
};

export const getContactUs = (payload) => {
  return {
    type: GET_CONTACTUS,
    payload: payload,
  };
};
export const getContactUsSuccess = (payload) => {
  return {
    type: GET_CONTACTUS_SUCCESS,
    payload: payload,
  };
};

export const getContactUsFailure = (error) => {
  return {
    type: GET_CONTACTUS_FAILURE,
    payload: error,
  };
};

export const deleteContactUs = (id) => {
  return {
    type: DELETE_CONTACTUS,
    payload: id,
  };
};

export const deleteContactUsSuccess = (id) => {
  return {
    type: DELETE_CONTACTUS_SUCCESS,
    payload: id,
  };
};

export const deleteContactUsFailure = (error) => {
  return {
    type: DELETE_CONTACTUS_FAILURE,
    payload: error,
  };
};

export const addContactUs = (payload) => {
  return {
    type: ADD_CONTACTUS,
    payload: payload,
  };
};
export const addContactUsSuccess = (payload) => {
  return {
    type: ADD_CONTACTUS_SUCCESS,
    payload: payload,
  };
};

export const addContactUsFailure = (error) => {
  return {
    type: ADD_CONTACTUS_FAILURE,
    payload: error,
  };
};
